// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__NHA5Z","spin":"Spinner_spin__6YUBE"};